var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"LunaCityArcadeMirror",attrs:{"fluid":""}},[_c('iframe',{attrs:{"src":"./Mirrors/LunaCityArcade/index.html","height":"100%","width":"100%","onload":"this.contentWindow.focus()"}})])}
var staticRenderFns = []

export { render, staticRenderFns }